import { List, NeoModel } from "@singularsystems/neo-core";
import { Views } from "@singularsystems/neo-react";
import { AppService, Types } from "../../../App/Services/AppService";
import StaticServiceProviderFileGroupingModel from "../../../Common/Models/StaticServiceProviderFileGroupingModel";
import { TextConstants } from "../../../Common/TextConstants";
import FileTypeLookup from "../../FileGroupingFileSpecs/Models/Lookups/FileTypeLookup";
import DestinationTableLookup from "../Models/Lookups/DestinationTableLookup";
import RawGenericMappingLookup from "../Models/Lookups/RawGenericMappingLookup";
import SourceFieldStaticOptionLookup from "../Models/Lookups/SourceFieldStaticOptionLookup";

@NeoModel
export default class ManageRawGenericMappingComponentVM extends Views.ViewModelBase {
    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        public generalApiClient = AppService.get(Types.ApiClients.GeneralApiClient),
        public rawGenericMappingApiClient = AppService.get(Types.ApiClients.RawGenericMappingApiClient),
        public fileGroupingFileSpecApiClient = AppService.get(Types.ApiClients.FileGroupingFileSpecApiClient),
    ) 
        {
            super(taskRunner);
        }   

    public managedGenericMapping = new RawGenericMappingLookup();
    public fileSpecList = new List(FileTypeLookup);
    public fileGroupingList = new List(StaticServiceProviderFileGroupingModel);
    public destinationTableList = new List(DestinationTableLookup);
    public sourceFieldList = new List(SourceFieldStaticOptionLookup);
    public isFieldReadOnlyInd: boolean = false;
    public sourceFieldIsCalculation: boolean = false;
    public sourceFieldIsDefault: boolean = false;
    public sourceFieldIsFreeText: boolean = false;

    public async initialise() {
        await this.loadFileGroupings();
        await this.loadFileSpecs();
        await this.loadDestinationTables();
        await this.loadSourceFieldOptions();

    }

    public async loadDestinationTables() {
        const response = await this.taskRunner.waitFor(this.rawGenericMappingApiClient.getDestinationTablesList());
        this.destinationTableList.set(response.data);
    }

    public setDestinationTableName(destinationTableID: number) {
        this.managedGenericMapping.rawGenericDestinationTableName = this.destinationTableList.find(x => x.destinationTableId === destinationTableID)?.destinationTableName!;
    }

    public async loadFileGroupings() {
        const response = await this.taskRunner.waitFor(this.generalApiClient.getStaticServiceProviderFileGroupingList());
        this.fileGroupingList.set(response.data);
    }

    public async loadFileSpecs() {
        const response = await this.taskRunner.waitFor(this.fileGroupingFileSpecApiClient.getFileSpecList());
        this.fileSpecList.set(response.data);
    }

    public async loadSourceFieldOptions() {
        const response = await this.taskRunner.waitFor(this.rawGenericMappingApiClient.getSourceFieldsList());
        this.sourceFieldList.set(response.data);
    }

    public validateSourceFieldValue() {
        this.setSourceFieldValuesToFalse();
        switch (this.managedGenericMapping.rawGenericSourceField) {
            case TextConstants.SourceFieldStaticOptions.Calc:
                this.sourceFieldIsCalculation = true;
                break;
            case TextConstants.SourceFieldStaticOptions.Default:
                this.sourceFieldIsDefault = true;
                break;
        }
    }

    public setSourceFieldValuesToFalse() {
        this.sourceFieldIsCalculation = false;
        this.sourceFieldIsDefault = false;
        this.sourceFieldIsFreeText = false;
    }


}